import { useEffect, useState } from "react";

const DELAY = 200;

const useShowNoResults = ({ searchInput, debouncedQuery, enabled, isFetching, isLoading, searchResult }) => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		let timeoutId;

		const isQueryStable = searchInput.trim() === debouncedQuery.trim();

		const shouldBlock = !enabled || !isQueryStable || isFetching;

		const hide = () => {
			clearTimeout(timeoutId);
			setVisible(false);
		};

		if (shouldBlock) {
			hide();
			return;
		}

		const { items = [], user_items = [], favorite = [], user_recipes = [], recipes = [] } = searchResult;

		const fetchDone = !isLoading && !isFetching;

		const isEmpty = [items, user_items, favorite, user_recipes, recipes].every((arr) => arr.length === 0);

		if (fetchDone && isEmpty) timeoutId = setTimeout(() => setVisible(true), DELAY);
		else hide();

		return () => clearTimeout(timeoutId);
	}, [enabled, searchInput, debouncedQuery, isFetching, isLoading, searchResult]);

	return visible;
};
export default useShowNoResults;
